module.exports = __webpack_public_path__ + "static/wholesale-two-banner-sale-a5512eca15da78e9984b8a815f276751.png";